import React from 'react';
import { Link } from 'react-router-dom';

function PaginaText({ titlu, continut }) {
  return (
    <div className="min-h-screen bg-[#f8fafc] font-sans text-gray-900 flex flex-col">
      <div className="flex-grow max-w-4xl mx-auto w-full px-4 py-16">
        <div className="mb-8">
          <Link to="/" className="text-sm font-bold text-blue-600 hover:text-blue-800 flex items-center gap-2">
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" /></svg>
            Inapoi la prima pagina
          </Link>
        </div>
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 md:p-12">
          <h1 className="text-3xl font-black text-gray-900 mb-8 pb-4 border-b border-gray-100">{titlu}</h1>
          <div className="text-gray-600 leading-loose whitespace-pre-wrap text-lg">
            {continut}
          </div>
        </div>
      </div>
    </div>
  );
}

export default PaginaText;